import { useEffect, useState } from 'react'

/**
 * `prefers-reduced-motion: reduce` ni kuzatadi. Animation guard uchun.
 */
export default function useReducedMotion() {
  const [reduced, setReduced] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
  })

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)')
    const onChange = (e) => setReduced(e.matches)
    mq.addEventListener?.('change', onChange) || mq.addListener?.(onChange)
    return () => {
      mq.removeEventListener?.('change', onChange) || mq.removeListener?.(onChange)
    }
  }, [])

  return reduced
}
